/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function iban ({ value, validationValue }) {
  if (!validationValue) return true
  if (!value) return false

  const val = value
    .toString()
    .replace(/\s/g, '')

  let countryCode = val?.substr(0, 2)?.toUpperCase()
  if (countryCode !== 'FI') return false

  countryCode = '1518' // Numbers corresponding to "FI"

  const checksum = val.substr(2, 2)
  const remainder = val.substr(4)

  const validationSequence = remainder + countryCode + checksum

  let m = 0
  for (let i = 0; i < validationSequence.length; ++i) {
    m = (m * 10 + parseInt(validationSequence.charAt(i))) % 97
  }

  return m === 1
}

module.exports = { iban }
